import React from "react"
import { AppDetailRouteComponentProps } from "../../RouteProps"
import { AppAuthCheck } from "../../../Components/Common/AuthCheck/AppAuthCheck"
import { AppCustomizeJobParameters } from "../../../Components/Views/Dashboard/Sections/AppDetail/Customize/Modes/Parameters/JobSettings"

export function AppCustomizeJobParametersRoute({
    match
}: AppDetailRouteComponentProps) {
    return (
        <AppAuthCheck {...match.params} scope="task-design:view">
            <AppCustomizeJobParameters {...match.params} />
        </AppAuthCheck>
    )
}
